import type { ConstValues } from '@openx/types/helpers.ts';

export const segmentsListTabs = {
  AUDIENCE_SEGMENTS: 'audience',
  LOOKALIKE_SEGMENTS: 'lookalike',
} as const;
export type SegmentsListTabs = ConstValues<typeof segmentsListTabs>;
